import React from 'react';
import styled from '../../styled';
const BlockMessagePageContainer = styled.div `
  height: calc(100vh - 4.125rem);
  min-height: 40rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1rem;
  margin-right: 1rem;
  text-align: center;
`;
const Title = styled.div `
  margin-bottom: 0.25rem;
`;
const Image = styled.div `
  margin-bottom: 1.5rem;
`;
const BlockMessagePage = ({ image, alt = 'not authorized', title, description, }) => {
    return (React.createElement(BlockMessagePageContainer, null,
        React.createElement("div", null,
            React.createElement(Image, null,
                React.createElement("img", { src: image, alt: alt })),
            React.createElement(Title, null, title),
            description)));
};
export default BlockMessagePage;
//# sourceMappingURL=BlockMessagePage.js.map